import ModalAdminCreate from './ModalAdminCreate';

export default ModalAdminCreate;
